import {toDecimalFromMoney} from "../../../../lib/Money.ts";
import type {BankBalanceCheck} from "../types/types.ts";

export function selectBankBalanceMismatches(
    checks: BankBalanceCheck[] | null | undefined,
): BankBalanceCheck[] {
    return (checks ?? []).filter((check) => check.status === 'mismatch');
}

export function bankBalanceTooltipText(check: BankBalanceCheck): string {
    const derived = toDecimalFromMoney(check.derived_balance).toFixed(2);
    const actual = check.actual_balance ? toDecimalFromMoney(check.actual_balance).toFixed(2) : '-';
    const difference = check.difference ? toDecimalFromMoney(check.difference).toFixed(2) : '-';
    return `Boekhoudkundig saldo ${derived} ${check.currency}, banksaldo ${actual} ${check.currency}, verschil ${difference} ${check.currency}.`;
}

export function bankBalanceCheckLabel(check: BankBalanceCheck): string {
    return check.label || 'Bankrekening';
}
